/* eslint-disable no-undef */
import React from 'react';
import PropTypes from 'prop-types';
import { withFormik } from 'formik';
import httpService from "../../../../api/httpLocationService";
import './VirtualTourHorizontalForm.scss';

const VirtualTourHorizontalForm = (props) => {
  const {
    path,
    cities,
    formAuthToken,
    handleSubmit,
    handleChange,
    handleBlur,
    touched,
    errors,
    values,
  } = props;

  return (
    <div className="box-shadow">
      <div className="content">
        <div className="virtualTourForm">
          <h3 className="sidebar-header arrowed arrowed--o colored--o">{I18n.t('virtual_office.form.legend')}</h3>
          <form
            id="virtual-tour-form-horizontal"
            className="virtual-tour-form virtual-horizontal"
            acceptCharset="UTF-8"
            onSubmit={handleSubmit}
          >

            <div className="row">
              <div className="col-xs-12 col-sm-4">
                <input
                  name="utf8"
                  type="text"
                  defaultValue="✓"
                  onChange={() => {}}
                  hidden
                />

                <input
                  name="authenticity_token"
                  value={formAuthToken}
                  type="hidden"
                />

                <div className="virtual-form-group">
                  <label htmlFor="area">{I18n.t('virtual_office.form.city')}</label>
                  <select
                    name="area"
                    value={values.area}
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      touched.area ? (errors.area ? 'error' : 'is-valid') : null
                    }
                  >
                    {cities.map(city => (
                      <option key={city.name} value={city.uri ? city.name : ''}>{city.name}</option>
                    ))}
                  </select>
                  <div className="validation-message">
                    {errors.area ? errors.area : null}
                  </div>
                </div>

                <div className="virtual-form-group">
                  <label htmlFor="company">{I18n.t('virtual_office.form.company')}</label>
                  <input
                    value={values.company}
                    name="company"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      touched.company ? (errors.company ? 'error' : 'is-valid') : null
                    }
                  />

                  <div className="validation-message">
                    {touched.company && errors.company ? errors.company : null}
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-4">
                <div className="virtual-form-group">
                  <label htmlFor="name">{I18n.t('virtual_office.form.name')}</label>
                    <input
                      value={values.name}
                      name="name"
                      onChange={handleChange}
                      onBlur={handleBlur}
                      className={
                        touched.name ? (errors.name ? 'error' : 'is-valid') : null
                      }
                    />
                  <div className="validation-message">
                    {touched.name && errors.name ? errors.name : null}
                  </div>
                </div>
                <div className="virtual-form-group">
                  <label htmlFor="phone">{I18n.t('virtual_office.form.phone')}</label>
                  <input
                    value={values.phone}
                    name="phone"
                    onChange={handleChange}
                    onBlur={handleBlur}
                    className={
                      touched.phone ? (errors.phone ? 'error' : 'is-valid') : null
                    }
                  />

                  <div className="validation-message">
                    {touched.phone && errors.phone ? errors.phone : null}
                  </div>
                </div>
              </div>

              <div className="col-xs-12 col-sm-4">
                <div className="virtual-form-group">
                  <label htmlFor="email">{I18n.t('virtual_office.form.email')}</label>
                  <input
                    name="email"
                    value={values.email}
                    onChange={handleChange}
                  />

                  <div className="validation-message">
                    {touched.email && errors.email ? errors.email : null}
                  </div>
                </div>

                <button
                  className="form-submit"
                  type="submit"
                  ref={btn => {this.virtualTourSubmitButton = btn}}
                >
                  {I18n.t('virtual_office.form.submit')}
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

VirtualTourHorizontalForm.propTypes = {
  path: PropTypes.string,
  cities: PropTypes.arrayOf(PropTypes.object),
  formAuthToken: PropTypes.string,
};

VirtualTourHorizontalForm.defaultProps = {
  path: '',
  cities: [],
  formAuthToken: '',
};

const ValidateVirtualTourForm = withFormik({
  mapPropsToValues: (bag) => ({
    company: '', name: '', phone: '', email: '', authenticity_token: bag.formAuthToken
  }),


  validate: values => {
    let errors = {};
    if (!values.name) {
      errors.name = I18n.t('sidebar.order.form.required-field');
    }
    if (!values.company) {
      errors.company = I18n.t('sidebar.order.form.required-field');
    }

    if (!values.email) {
      errors.email = I18n.t('sidebar.order.form.required-field');
    } else if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(
        values.email
      )
    ) {
      errors.email = I18n.t('sidebar.order.form.invalid-email');
    }

    if (!values.phone) {
      errors.phone = I18n.t('sidebar.order.form.required-field');
    } else if (
      !/^\+?([\d]*\d){10,}$/i.test(
        values.phone.replace(/[-\s()]/g, '')
      )
    ) {
      errors.phone = I18n.t('sidebar.order.form.invalid-phone');
    }

    if (!values.area) {
      errors.area = I18n.t('sidebar.order.form.required-field');
    }

    return errors;
  },

  handleSubmit: (values, bag) => {
    this.virtualTourSubmitButton.setAttribute("disabled", "disabled");

    httpService.virtualTourForm(values, bag.props.path, bag.props.formAuthToken)
      .then(() => {
        window.location.replace('/orders/success?type=virtual_office');
      });
  },

  displayName: 'VirtualTourHorizontalForm', // helps with React DevTools
})(VirtualTourHorizontalForm);

export default ValidateVirtualTourForm;

// export default VirtualTourHorizontalForm;
